jQuery(function() {

    const container = jQuery('.google-map');

    container.find('iframe').css('pointer-events', 'none');

    container.click(() => {
        jQuery(this)
            .find('iframe')
            .css('pointer-events', 'auto');
    }).mouseleave(() => {
        jQuery(this)
            .find('iframe')
            .css('pointer-events', 'none');
    });
});



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/google-map-scroll-hack.js